import { CardContainer } from "./CardContainer"
import { CardStat } from "./CardComps"
import LaunchIcon from "@mui/icons-material/Launch"
import { IconButton } from "@mui/material"
import { Link } from "react-router-dom"
import routes from "../../constants/routes"

const StaffCard = ({ data }) => (
  <CardContainer
    disableEditDelete
    SummaryContent={
      <>
        <CardStat label="Name" value={data?.user_?.name} />
        <CardStat label="Designation" value={data?.designation} />
        <CardStat label="Institute" value={"-"} />
        <CardStat label="Employment Period" value={`${data?.contractStartDate ? data.contractStartDate.split("T")[0] : ""} - ${data?.contractEndDate ? data.contractEndDate.split("T")[0] : ""}`} />
      </>
    }
    DetailsContent={
      <>
        <CardStat label="Username" value={data?.user_?.username} />
        <CardStat label="Phone Number" value={data?.user_?.phoneNumber} />
        <CardStat label="Email" value={data?.user_?.email} />
      </>
    }
    ActionButtons={
      <Link to={`${routes.ADMIN.STAFFS}/${data?.staffUser}`}>
        <IconButton>
          <LaunchIcon />
        </IconButton>
      </Link>
    }
  />
)

export default StaffCard
